const SELECT_EXPIRATION = 'select_expiration';
const PLAY_VIDEO = 'PLAY_VIDEO';
const SET_APP_STATE = 'SET_APP_STATE';
const SET_UOA_STATE = 'SET_UOA_STATE';
const SET_UOA_FILTER = 'SET_UOA_FILTER';
const SET_OPEN_INTREST = 'SET_OPEN_INTREST';
const SET_OPTION_CHAIN_STATE = 'SET_OPTION_CHAIN_STATE';
const ActionTypes = {
  SELECT_EXPIRATION,
  PLAY_VIDEO,
  SET_APP_STATE,
  SET_UOA_STATE,
  SET_UOA_FILTER,
  SET_OPEN_INTREST,
  SET_OPTION_CHAIN_STATE
};

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/actions/types.js